import { useState } from "react";

import { PatentListData } from "@/components/business/PatentContainer/Patent.types";
import { useGetCurrentEntryData } from "@hooks/useGetCurrentEntryData";
import useModal from "@hooks/useModal";

import PatentGuideModal from "../components/PatentGuideModal/PatentGuideModal";
import PatentPageEntryGuide from "../components/PatentPageEntryGuide/PatentPageEntryGuide";
import { useMovePatentDetailPage } from "../components/PatentTitleContainer/components/PatentTableShellForPatentTitle/hooks/useMovePatentDetailPage";

/**
 * 행 단위 공용 네비게이션 훅.
 * Title / Applicant 등 "클릭 시 디테일 페이지 이동"이 필요한 셀이 공유한다.
 * status 변경 알림 모달 없이 바로 진입하며(접근권한/동시접근 체크는
 * movePatentDetailPage 내부에서 수행), 클릭 핸들러(clickToMove)와
 * 렌더할 모달(modals)을 반환한다.
 */
export const usePatentRowNavigation = (
  patentListItem: PatentListData,
  updatePatentList: () => void,
) => {
  const [targetPatentId, setTargetPatentId] = useState(0);

  const { isModal, closeModal, openModal } = useModal();
  const {
    isModal: isGuideModal,
    closeModal: closeGuideModal,
    openModal: openGuideModal,
  } = useModal();

  const draftArticleId = patentListItem?.draftArticleId?.toString();
  const getEntryData = useGetCurrentEntryData(draftArticleId);

  const openAccessDeniedModal = () => {
    setTargetPatentId(patentListItem?.draftArticleId || 0);
    openGuideModal();
  };

  const openConcurrentAccessDeniedModal = () => {
    setTargetPatentId(patentListItem?.draftArticleId || 0);
    openModal();
  };

  const { movePatentDetailPage } = useMovePatentDetailPage({
    draftArticleId,
    publicationNumber: patentListItem?.publicationNumber,
    ftEditorName: patentListItem?.ftEditor2Name,
    onAccessDenied: openAccessDeniedModal,
    onConcurrentAccessDenied: openConcurrentAccessDeniedModal,
  });

  const clickToMove = async () => {
    getEntryData();
    sessionStorage.setItem("scrollPosition", window.scrollY.toString());
    await movePatentDetailPage();
  };

  const modals = (
    <>
      {isModal && (
        <PatentPageEntryGuide
          closeModal={closeModal}
          updatePatentList={updatePatentList}
        />
      )}
      {isGuideModal && (
        <PatentGuideModal
          closeModal={closeGuideModal}
          draftArticleId={targetPatentId}
        />
      )}
    </>
  );

  return { clickToMove, modals };
};
